import React from 'react'
import { useTheme, css } from '@emotion/react'
import clsx from 'clsx'

function Divider({
    orientation = 'horizental',
    tight,
    width,
    className,
    gap,
    color,
    size = '1px',
    height = 'md',
    style
}) {
    const theme = useTheme()

    function paddingSwitch(space) {
        const spacing = theme.spacing
        switch (space) {
            case 'xs':
                return spacing?.one
            case 'sm':
                return spacing?.two
            case 'md':
                return spacing?.four
            case 'lg':
                return spacing?.six
            case 'xl':
                return spacing?.eight
            case 'xxl':
                return spacing?.ten
            default:
                return spacing?.six
        }
    }

    return (
        <>
            {orientation === 'horizental' && (
                <hr
                    className={('divider', clsx(className))}
                    width={width}
                    css={css`
                        ${!tight &&
                        `margin-top: ${gap || paddingSwitch(height)};
                        margin-bottom: ${gap || paddingSwitch(height)};`}
                        display: block;
                        border-top-width: ${size};
                        ${color && `border-color: ${theme.colors?.[color]}`};
                        width:${width};
                        ${style}
                    `}
                />
            )}
        </>
    )
}

export default Divider
